import { useEffect, useRef } from "react";
/** Keep open work queues current; do not poll hidden browser tabs. */
export function useOrderRefresh(refresh: () => unknown) {
  const latest = useRef(refresh);
  useEffect(() => {
    latest.current = refresh;
  });
  useEffect(() => {
    let running = false;
    const run = async () => {
      if (running || document.visibilityState === "hidden") return;
      running = true;
      try {
        await latest.current();
      } finally {
        running = false;
      }
    };
    const safeRun = () => {
      void run().catch(() => {});
    };
    const timer = window.setInterval(safeRun, 10000);
    window.addEventListener("taunggyi:orders-updated", safeRun);
    document.addEventListener("visibilitychange", safeRun);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener("taunggyi:orders-updated", safeRun);
      document.removeEventListener("visibilitychange", safeRun);
    };
  }, []);
}
